import { MemoInterface } from "@carglassgithub/memod-sdk";
import { atom } from "jotai";

export const MemoAtom = atom<MemoInterface | null>(null);
